import React, { FC, RefObject, useEffect, useState } from 'react';

import { navigate, useLocation } from '@reach/router';
import { useConnector, useEthers } from '@usedapp/core';

import Modal from '@bitcoin-portal/verse-web-components/dist/Modal/Modal';

import { useEns } from '@context/providers/EnsProvider';

import { RABBY_AVATAR_URL, TEST_ACCOUNT } from '../../../../context/constants';

import { shortAddress } from '../../../../helpers';

import metamaskIcon from '../../../../../static/images/uploads/metamask.png';
import walletconnectIcon from '../../../../../static/images/uploads/walletconnect.png';

import { ConnectButton, DisconnectBubble, WalletDisplay } from './styled';

interface Props {
  loginModalRef?: RefObject<Modal>;
}

type WalletType = 'metamask' | 'rabby' | 'walletconnect';

const DisconnectButton: FC<Props> = ({ loginModalRef }) => {
  const { pathname } = useLocation();
  const username = useEns();
  const { account: ethersAccount, deactivate } = useEthers();
  const { connector } = useConnector();
  const account = TEST_ACCOUNT || ethersAccount;
  const [walletType, setWalletType] = useState<WalletType>('walletconnect');

  useEffect(() => {
    const name = connector?.connector?.name?.toLowerCase() ?? '';
    if (name === 'metamask') {
      setWalletType('metamask');
    } else if (name === 'rabby') {
      setWalletType('rabby');
    } else {
      setWalletType('walletconnect');
    }
  }, [connector]);

  const walletIconMap: Record<WalletType, string> = {
    metamask: metamaskIcon,
    rabby: RABBY_AVATAR_URL,
    walletconnect: walletconnectIcon,
  };
  const walletLabelMap: Record<WalletType, string> = {
    metamask: 'MetaMask',
    rabby: 'Rabby Wallet',
    walletconnect: 'WalletConnect',
  };
  const walletIcon = walletIconMap[walletType];
  const walletLabel = walletLabelMap[walletType];

  return (
    <ConnectButton
      fullWidth
      design="primary"
      onClick={(e: React.UIEvent<HTMLElement>) => {
        e.stopPropagation();
        deactivate();
        loginModalRef?.current?.close();

        if (pathname.includes('/pools/create')) {
          navigate('/pools/eth/');
        }
      }}
    >
      <div>
        <img
          src={walletIcon}
          width="32px"
          height="32px"
          alt="Connected wallet"
          style={
            walletType === 'rabby'
              ? { background: 'white', borderRadius: '50px' }
              : undefined
          }
        />
        <WalletDisplay>
          <span>{walletLabel}</span>
          <span>{username || shortAddress(account)}</span>
        </WalletDisplay>
      </div>
      <DisconnectBubble>Disconnect</DisconnectBubble>
    </ConnectButton>
  );
};

export default DisconnectButton;
